import { defaultQuoteData } from "../default-quote-event-data";

export const defaultPayNowData = {
  ...defaultQuoteData,
  ss_order_metrics: "XXXXXXX",
  postcode: "SE1 3GN",
  destination: "CountryCode",
};
